import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Tooltip} from "reactstrap";
import {FormattedMessage} from "react-intl";
import InputNumber from "components/InputNumber";

class AnswerMinValue extends Component{
  constructor(props) {
    super(props);
    this.state = {
      minValue: props.answer.minValue,
      tooltipIsOpen: false,
    };

    this.onChange = this.onChange.bind(this);
  }

  toggleTooltip(){
    this.setState({
      tooltipIsOpen: !this.state.tooltipIsOpen
    });
  }

  onChange(value) {
    this.setState({...this.state, minValue: value});
    this.props.changeOption('minValue', value);
  }

  render() {
    const {minValue, tooltipIsOpen} = this.state;

    return (
      <React.Fragment>
        <InputNumber float value={minValue} onChange={this.onChange} id={'answerMinValue-' + this.props.answer.id} placeholder="min"/>
        <Tooltip
          delay={0}
          placement="top"
          isOpen={tooltipIsOpen}
          target={'answerMinValue-' + this.props.answer.id}
          toggle={() => this.toggleTooltip()}
        >
          <FormattedMessage id="answer.answerMinValue.button.tooltip"/>
        </Tooltip>
      </React.Fragment>
    )
  }
}

AnswerMinValue.propTypes = {
  answer: PropTypes.shape({
    id: PropTypes.number.isRequired,
    minValue: PropTypes.number,
  }).isRequired,
  changeOption: PropTypes.func.isRequired
};

export default AnswerMinValue;
